import { FC } from 'react';
import supplierCreated from '../../../assets/supplierCreated.svg';

export const ParticipationWithdrawnSuccess: FC = () => (
    <div className="SupplierCompanyPitches__success success">
        <div className="success__block">
            {' '}
            <div className="preferences-submitted">
                <h1 className="preferences-submitted__title">Participation Withdrawn</h1>

                <p className="preferences-submitted__text">
                    Your decision to withdraw from this pitch has been recorded.
                </p>

                <p className="preferences-submitted__text">The Customer has been notified of your withdrawal.</p>
                <p className="preferences-submitted__text">
                    By withdrawing from the Supplier Pitch, you will no longer be considered for this opportunity.{' '}
                </p>
                <p className="preferences-submitted__text">No further action is required at this stage.</p>

                <div className="preferences-submitted__contact">
                    <p className="preferences-submitted__text">
                        If you have any questions, please contact the support team at{' '}
                        <a href="mailto:support@askproco.com" className="preferences-submitted__link">
                            support@askproco.com
                        </a>
                    </p>

                    <p className="preferences-submitted__text">
                        or contact us directly at{' '}
                        <span className="preferences-submitted__phone">+27 (0) 21 565 0401</span>
                    </p>
                </div>
            </div>
        </div>
        <img src={supplierCreated} className="image__item" />
    </div>
);
